// Generated by ReScript, PLEASE EDIT WITH CARE


var perminssion_denied = "User denied the request for Geolocation.";

var position_unavailable = "Location information is unavailable.";

var timeout = "The request to get user location timed out.";

var unknown_error = "An unknown error occurred while getting permission for current location";

var on_fetch_from_geocode_error = "Error on google geo code custom with retry";

var pickup_pin_icon_url = "https://nest-platform-assets.porter.in/pickup_map_pin_62f10677e2/pickup_map_pin_62f10677e2.svg";

var pickup_pin_tool_tip_url = "https://nest-platform-assets.porter.in/pickup_pin_tool_tip_e87924e8d8/pickup_pin_tool_tip_e87924e8d8.svg";

var drop_pin_tool_tip_url = "https://nest-platform-assets.porter.in/drop_pin_tool_tip_01b977a192/drop_pin_tool_tip_01b977a192.svg";

var drop_pin_icon_url = "https://nest-platform-assets.porter.in/drop_map_pin_a7e1482594/drop_map_pin_a7e1482594.svg";

var pickup_pin_icon_alt = "Pickup pin icon";

var pickup_pin_tool_tip_alt = "Pickup pin tool tip";

var drop_pin_tool_tip_alt = "Drop pin tool tip";

var drop_pin_icon_alt = "Drop pin icon";

export {
  perminssion_denied ,
  position_unavailable ,
  timeout ,
  unknown_error ,
  on_fetch_from_geocode_error ,
  pickup_pin_icon_url ,
  pickup_pin_tool_tip_url ,
  drop_pin_tool_tip_url ,
  drop_pin_icon_url ,
  pickup_pin_icon_alt ,
  pickup_pin_tool_tip_alt ,
  drop_pin_tool_tip_alt ,
  drop_pin_icon_alt ,
}
/* No side effect */
